 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"HighCharts":"HighCharts","AmCharts":"AmCharts","ApexChart":"ApexChart","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"HighCharts":"79c978f2","chunk-091b0918":"75676c85","AmCharts":"ee14ba2f","chunk-4ae81498":"f6f1fdfc","chunk-ceaa867c":"d9a45d60","chunk-7e9f6185":"78e9cc0a","chunk-c490784c":"6f06c784","chunk-1e730ef1":"bd4b7b0e","chunk-ac53f0ca":"607a10f9","chunk-0a7afad9":"feadf503","chunk-16deee08":"0ef087fb","chunk-1f6df109":"bbd4458d","chunk-20ee07b8":"6adfdd48","chunk-2635fd52":"f9ed8e23","chunk-26969f90":"1e7d4c9a","chunk-2d0a4c18":"10444f65","chunk-2d0aa641":"b45ff75c","chunk-2d0ac5dd":"e03e2e2b","chunk-2d0ae599":"43ff7895","chunk-2d0b3dcd":"e508b68e","chunk-2d0b8e0a":"f77b9818","chunk-2d0bacb6":"ed88d5d0","chunk-2d0bd5e9":"eb92c40c","chunk-2d0bfed3":"6bbfb239","chunk-2d0c04b2":"e53b96b0","chunk-2d0c5368":"3a26e568","chunk-2d0c5398":"e52b254f","chunk-2d0c7b81":"684deffc","chunk-2d0c840a":"802030a2","chunk-2d0cbad6":"c2a4c771","chunk-2d0cbe59":"35c9c38a","chunk-2d0cc807":"93795780","chunk-2d0ccbc7":"c123cb42","chunk-2d0cedba":"227fab19","chunk-2d0d3a0a":"f6d5ba28","chunk-2d0d5c6b":"5c56a02d","chunk-2d0d6377":"b90c5d47","chunk-2d0da2e7":"f59405b1","chunk-2d0e2123":"10708856","chunk-2d0e6514":"299d4b2c","chunk-2d207398":"f7bf2a39","chunk-2d207f54":"6b6beeb4","chunk-2d209132":"2bf5a1ce","chunk-2d20f7a3":"2cab66ad","chunk-2d216798":"b8005cc5","chunk-2d217eb6":"8e1e05cf","chunk-2d219fca":"90fd37fe","chunk-2d21d826":"d6aa2d6b","chunk-2d226159":"f69c0225","chunk-2d2268fd":"014a7cc9","chunk-2d2374f7":"2beb0d42","chunk-2d238257":"641da33f","chunk-2d5809e0":"5c064546","chunk-3a52e903":"d511bfcc","chunk-3c1a52a8":"0dbe9ec6","chunk-49072f5f":"40af339f","chunk-4a49d1f9":"3f005f91","chunk-245d1fa7":"93324f93","chunk-2d0c46e5":"338ff7b2","chunk-66ae30bc":"a34175a6","chunk-7eb2e5e8":"8b1f7ac1","chunk-56b5dad4":"253be8f9","chunk-58ef6d76":"8b4eb45d","chunk-5af2ec7c":"3c9671c6","chunk-62fe045e":"5c9fffe3","chunk-6e2c2370":"d9cea140","chunk-73f8482a":"91f3c6b8","chunk-4d58876c":"76599b93","chunk-6c0783c2":"559d1f07","chunk-28dec7fb":"41e05340","chunk-d69e892c":"0fbdbe43","chunk-b3b78c88":"c914c9c3","chunk-78b53006":"a307fcbc","chunk-88295540":"21f69134","chunk-8829adea":"1d0cf184","chunk-89c08f40":"abb824b2","chunk-8ccb5468":"0dca2ec3","chunk-af6aabda":"fe8a7a94","chunk-ba306e70":"312968c3","chunk-c0788482":"c31d0f41","ApexChart":"6c7850d2","chunk-1bd5e7cf":"3b57d48b","chunk-c944c0e8":"6637645d","chunk-cdbe2c3a":"955d4177","chunk-23adc968":"c8b753a9","chunk-2648cbde":"b3643023","chunk-2d21d9f2":"f50a6a44","chunk-d37b5e1e":"1cfb678b","canvg":"12d54e9f","pdfmake":"b17ba0e4","xlsx":"459fa557","chunk-e309b562":"d473f5c1","chunk-2d2222f9":"6aea66bf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-4ae81498":1,"chunk-ac53f0ca":1,"chunk-16deee08":1,"chunk-26969f90":1,"chunk-49072f5f":1,"chunk-245d1fa7":1,"chunk-7eb2e5e8":1,"chunk-58ef6d76":1,"chunk-73f8482a":1,"chunk-4d58876c":1,"chunk-6c0783c2":1,"chunk-28dec7fb":1,"chunk-d69e892c":1,"chunk-b3b78c88":1,"chunk-ba306e70":1,"chunk-c0788482":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"HighCharts":"HighCharts","AmCharts":"AmCharts","ApexChart":"ApexChart","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"HighCharts":"31d6cfe0","chunk-091b0918":"31d6cfe0","AmCharts":"31d6cfe0","chunk-4ae81498":"39d8f518","chunk-ceaa867c":"31d6cfe0","chunk-7e9f6185":"31d6cfe0","chunk-c490784c":"31d6cfe0","chunk-1e730ef1":"31d6cfe0","chunk-ac53f0ca":"f2172597","chunk-0a7afad9":"31d6cfe0","chunk-16deee08":"9db3d878","chunk-1f6df109":"31d6cfe0","chunk-20ee07b8":"31d6cfe0","chunk-2635fd52":"31d6cfe0","chunk-26969f90":"374a13c2","chunk-2d0a4c18":"31d6cfe0","chunk-2d0aa641":"31d6cfe0","chunk-2d0ac5dd":"31d6cfe0","chunk-2d0ae599":"31d6cfe0","chunk-2d0b3dcd":"31d6cfe0","chunk-2d0b8e0a":"31d6cfe0","chunk-2d0bacb6":"31d6cfe0","chunk-2d0bd5e9":"31d6cfe0","chunk-2d0bfed3":"31d6cfe0","chunk-2d0c04b2":"31d6cfe0","chunk-2d0c5368":"31d6cfe0","chunk-2d0c5398":"31d6cfe0","chunk-2d0c7b81":"31d6cfe0","chunk-2d0c840a":"31d6cfe0","chunk-2d0cbad6":"31d6cfe0","chunk-2d0cbe59":"31d6cfe0","chunk-2d0cc807":"31d6cfe0","chunk-2d0ccbc7":"31d6cfe0","chunk-2d0cedba":"31d6cfe0","chunk-2d0d3a0a":"31d6cfe0","chunk-2d0d5c6b":"31d6cfe0","chunk-2d0d6377":"31d6cfe0","chunk-2d0da2e7":"31d6cfe0","chunk-2d0e2123":"31d6cfe0","chunk-2d0e6514":"31d6cfe0","chunk-2d207398":"31d6cfe0","chunk-2d207f54":"31d6cfe0","chunk-2d209132":"31d6cfe0","chunk-2d20f7a3":"31d6cfe0","chunk-2d216798":"31d6cfe0","chunk-2d217eb6":"31d6cfe0","chunk-2d219fca":"31d6cfe0","chunk-2d21d826":"31d6cfe0","chunk-2d226159":"31d6cfe0","chunk-2d2268fd":"31d6cfe0","chunk-2d2374f7":"31d6cfe0","chunk-2d238257":"31d6cfe0","chunk-2d5809e0":"31d6cfe0","chunk-3a52e903":"31d6cfe0","chunk-3c1a52a8":"31d6cfe0","chunk-49072f5f":"5405d2da","chunk-4a49d1f9":"31d6cfe0","chunk-245d1fa7":"3e7622d9","chunk-2d0c46e5":"31d6cfe0","chunk-66ae30bc":"31d6cfe0","chunk-7eb2e5e8":"ac9be05d","chunk-56b5dad4":"31d6cfe0","chunk-58ef6d76":"17486d2a","chunk-5af2ec7c":"31d6cfe0","chunk-62fe045e":"31d6cfe0","chunk-6e2c2370":"31d6cfe0","chunk-73f8482a":"d8e40da7","chunk-4d58876c":"92647ec0","chunk-6c0783c2":"199205e6","chunk-28dec7fb":"3e86c0ce","chunk-d69e892c":"92647ec0","chunk-b3b78c88":"d153a058","chunk-78b53006":"31d6cfe0","chunk-88295540":"31d6cfe0","chunk-8829adea":"31d6cfe0","chunk-89c08f40":"31d6cfe0","chunk-8ccb5468":"31d6cfe0","chunk-af6aabda":"31d6cfe0","chunk-ba306e70":"f2c145df","chunk-c0788482":"c1d12eb6","ApexChart":"31d6cfe0","chunk-1bd5e7cf":"31d6cfe0","chunk-c944c0e8":"31d6cfe0","chunk-cdbe2c3a":"31d6cfe0","chunk-23adc968":"31d6cfe0","chunk-2648cbde":"31d6cfe0","chunk-2d21d9f2":"31d6cfe0","chunk-d37b5e1e":"31d6cfe0","canvg":"31d6cfe0","pdfmake":"31d6cfe0","xlsx":"31d6cfe0","chunk-e309b562":"31d6cfe0","chunk-2d2222f9":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["chunk-091b0918","AmCharts","chunk-c490784c","ApexChart","HighCharts"]]);
 	return startupResult;
